import React from 'react';
import { useWeather } from '../../context';
import { Select } from '../ui/Select';

export function TriggerControls() {
  const { 
    triggerOperator, 
    setTriggerOperator,
    triggerValue,
    setTriggerValue,
    modelSelect,
    stormFilter,
    parameterSelect
  } = useWeather();

  // Show for OpenMeteo or any storm report type except tornado
  const showTrigger = modelSelect === 'openmeteo' || 
    (modelSelect === 'xweather' && 
     parameterSelect === 'storm_reports' && 
     stormFilter !== 'tornado' &&
     stormFilter !== 'all');

  if (!showTrigger) {
    return null;
  }

  let label = 'Parametric Trigger';
  let unit = '';

  if (modelSelect === 'xweather') {
    switch (stormFilter) {
      case 'hail':
        label = 'Hail Size Trigger';
        unit = 'inches';
        break;
      case 'blizzard':
      case 'snow':
        label = 'Snow Accumulation Trigger';
        unit = 'inches';
        break;
      case 'ice':
        label = 'Ice Accumulation Trigger';
        unit = 'inches';
        break;
      case 'rain':
        label = 'Rainfall Trigger';
        unit = 'inches';
        break;
      case 'wind':
        label = 'Wind Speed Trigger';
        unit = 'mph';
        break;
      case 'flood':
        label = 'Flood Depth Trigger';
        unit = 'feet';
        break;
    }
  }

  return (
    <div className="mb-6 space-y-4">
      <h3 className="text-sm font-medium text-[var(--secondary-text)]">
        {label}
      </h3>
      
      <div className="flex gap-2">
        <Select
          value={triggerOperator}
          onChange={(e) => setTriggerOperator(e.target.value)}
          options={[
            { value: '>', label: 'Greater Than' },
            { value: '<', label: 'Less Than' }
          ]}
        />
        
        <input
          type="number"
          value={triggerValue}
          onChange={(e) => setTriggerValue(Number(e.target.value))}
          step="0.1"
          min="0"
          className="input flex-1"
          placeholder="Trigger value"
        />
      </div>
      
      <p className="text-xs text-[var(--secondary-text)]">
        Values {triggerOperator} {triggerValue}{unit ? ` ${unit}` : ''} will be highlighted in red
      </p>
    </div>
  );
}